import { Lead } from '@betterfunnel/types';
import { collection, query, where } from 'firebase/firestore';
import { useContext, useMemo } from 'react';
import { LeadsTable } from '../../components/LeadsTable';
import { DashboardContext } from '../../contexts/DashboardContext';
import { UserContext } from '../../contexts/UserContext';
import { emptyConverter } from '../../utils';

export default function ManageDynamicPageLeads() {
  const { selectedAccount } = useContext(UserContext);
  const { selectedDynamicPage } = useContext(DashboardContext);

  const leadsQuery = useMemo(() => {
    if (!selectedAccount || !selectedDynamicPage) return;
    return query(
      collection(selectedAccount.ref, 'leads').withConverter(
        emptyConverter<Lead>(),
      ),
      where('campaignId', '==', selectedDynamicPage.id),
    );
  }, [selectedAccount, selectedDynamicPage]);

  return (
    <div className="relative h-full w-full flex-1">
      {leadsQuery && <LeadsTable query={leadsQuery} />}
    </div>
  );
}
